import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import { BasicForm } from 'react-serial-forms';
import isLoggedIn from '../utils/index';
import { doVerifyEmail } from '../actions';
import { getNextOnBoardingStep } from '../utils/index';
import {ONBOARDING_STEPS_MAP} from '../constants.js'
import NotFound from '../containers/NotFound'

const ensureAbsoluteUrl = (url) => (url && url.length > 0 && url[0] != '/' ? '/' + url : url);


class VerifyEmail extends Component {

  componentWillMount() {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }

    this.props.doVerifyEmail({ key: this.props.params.verificationKey });
  }

  componentWillReceiveProps(nextProps) {
    const { auth } = this.props
    const { nextUrl } = nextProps.verifyEmail

    const { auth: nextAuth } = nextProps
    if (nextAuth && nextAuth.user && nextAuth.user.verified) {
      this.props.push(getNextOnBoardingStep(nextAuth.user))
    }
  }

  render() {

    const { isExpired, isLoading, isVerifed, wasNotFound } = this.props.verifyEmail

    if (isLoading) {
      return <span/>
    }

    if (wasNotFound) {
      return <NotFound />
    }


    let message = 'Verifying your email address';

    if(!isVerifed) {
      message = 'Your email has been verified';
    } else if (isExpired) {
      message = 'Looks like your email activation key link has expired';
    }

    return (
      <div className="verifyEmail">
        <center>
          <h2>{message}</h2>
          {isExpired ? (
            <Link to={'/join?next=/user/emailverification?send=expired'}><button>Send again!</button></Link>
          ) : (isVerifed ? (
            <Link to={'/login'} className="button button-primary">Continue to login</Link>
          ) : null)}
        </center>
      </div>
    );
  }

};

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    doVerifyEmail
  }
)(VerifyEmail);



// WEBPACK FOOTER //
// ./src/containers/VerifyEmail.jsx